import * as React from "react";
let DatePicker = require("shared/lib/react-datepicker/index.jsx").default;
import 'shared/lib/react-datepicker/stylesheets/datepicker.scss';
import {LocalizeDate} from "InternalShared/Localization/LocalizeDate";
import {GetModel} from "FormBuilder/Events/GetModel";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {FBFieldWithPriceBase, FBFieldWithPriceBaseState} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";
import {PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBFieldBaseProps} from "FormBuilder/Fields/Core/FBFieldBase";
import {FBDatePickerModel} from "./FBDatePicker.Model";
import {FBDatePickerOptions} from "./FBDatePicker.options";
import {EventManager} from "shared/core/Events/EventManager";
import {DateUtilities} from "FormBuilder/Utilities/DateUtilities";
import {IconOrImagePlaceholder} from "FormBuilder/Fields/Core/SubComponents/IconOrImagePlaceholder";
import './FBDatePicker.css';

export class FBDatePicker extends FBFieldWithPriceBase<FBTextFieldProps,FBTextFieldState>{

    static defaultProps: Partial<FBTextFieldProps> = {

    };

    public LocaleToUse:any;
    constructor(props: FBTextFieldProps) {
        super(props);
        this.LocaleToUse=LocalizeDate.GetLocale(props.Model.Options.WeekStartOn);
    }

    componentWillReceiveProps(nextProps: Readonly<FBTextFieldProps>, nextContext: any): void {
        if(this.Model.Parent.IsDesign)
        {
            this.Model.Quantity=this.Model.Options.QuantityDefaultValue==''?"": this.Model.ParseNumber(this.Model.Options.QuantityDefaultValue);
            this.Model.CalculateDefaultDate();
            this.Model.CalculateDateFormat();
        }

    }

    SubRender() {
        if(this.props.Model.Options.ShowQuantitySelector&&this.props.Model.Options.PriceType!=PriceTypeEnum.quantity)
        {
            return(
            this.props.Model.Options.QuantityPosition == "bottom" || this.props.Model.Options.QuantityPosition == "right" ?
                <React.Fragment>
                    {this.GetInput(this.props.Model.Options.QuantityPosition)}
                    {this.GetQuantityInput()}

                        {this.GetPriceOrRequiredBox()}

                </React.Fragment>:
                <React.Fragment>
                    {this.GetQuantityInput()}
                    {this.GetInput(this.props.Model.Options.QuantityPosition)}

                        {this.GetPriceOrRequiredBox()}

                </React.Fragment>
            )
        }
        return(
            <React.Fragment>
                {this.GetInput('')}

                    {this.GetPriceOrRequiredBox()}

            </React.Fragment>
        )


    }






    GetQuantityInput(){
        return(
            <div className={'rnTextFieldQuantity '+ this.props.Model.Options.QuantityPosition}>
                <div className={'rednaoLabel'}>
                    <label style={{fontWeight:'bold'}}>{this.props.Model.Options.QuantityLabel}</label>
                </div>
                <input className={'rnInputQuantity'} placeholder={this.Model.Options.QuantityPlaceholder} style={{width:'100%'}} type={'text'} value={this.Model.Quantity}
                       onChange={x=>{this.Model.Quantity=this.Model.ParseNumber(x.target.value as any);this.Model.Refresh()}}/>
            </div>

        )
    }

    GetInput(additionalClassNames:string){
        let date:any=this.Model.Date;
        if(date>0)
        {
            date=new Date(this.Model.Date*1000);
            date=new Date(date.setMinutes(date.getMinutes()+date.getTimezoneOffset()))
        }else
            date=null;
        return (
            <div className={'rnTextFieldInput '+ additionalClassNames+(this.Model.IsFocused?' RNFocus':'')}>
                {this.GetLabel()}
                <IconOrImagePlaceholder styles={{zIndex:1}} Icon={this.props.Model.Options.Icon} Model={this.Model}>
                    {(styles,classes)=>
                        <DatePicker onFocus={()=>{this.Model.IsFocused=true;this.Model.Refresh()}} onBlur={()=>{this.Model.IsFocused=false;this.Model.Refresh()}}  locale={LocalizeDate.GetLocale()} selected={date} placeholderText={this.Model.Options.Placeholder}  className={'rndatepicker-control '+classes} dateFormat={this.Model.DateFormat} onChange={e=>this.OnChange(e)}
                                    showMonthDropdown
                                    showYearDropdown
                                    showTimeSelect={this.props.Model.Options.EnableTimePicker}
                                    dropdownMode="select"
                        />
                    }
                </IconOrImagePlaceholder>
            </div>

        );
    }






    private OnChange(x:Date) {
        this.Model.Date=DateUtilities.DateToUnix(x);
        this.Model.FireValueChanged();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBTextFieldProps extends FBFieldBaseProps{
    Model:FBDatePickerModel;
}

interface FBTextFieldState extends FBFieldWithPriceBaseState{

}



EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.Datepicker)
        return new FBDatePickerModel(event.Options as FBDatePickerOptions,event.parent).Initialize(event.PreviousData);
});


EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.Datepicker)
        return new FBDatePickerOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.Datepicker)
        return <FBDatePicker Model={event.Model as FBDatePickerModel} />
});


//#endregion "My Region"